import React, { useState } from 'react';
import { Location } from '../../../../types';
import { DEFAULT_ZOOM } from '../../../_shared/constants';
import { Map } from './Map';
import { StaticMap } from './StaticMap';

export const MapWithStaticPlaceholder = ({
    location,
    gMapsApiKey,
}: {
    location: Location;
    gMapsApiKey: string;
}) => {
    const [showInteractiveMap, setShowInteractiveMap] = useState(false);

    if (!showInteractiveMap) {
        return <StaticMap onClick={() => setShowInteractiveMap(true)} />;
    }

    return (
        <Map
            location={location}
            gMapsApiKey={gMapsApiKey}
            mapZoom={DEFAULT_ZOOM}
        />
    );
};
